/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_UrlInputs */

const cs_projects_url = /** @type {(inputs: Projects_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL projektu`)
};

const en_projects_url = /** @type {(inputs: Projects_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project URL`)
};

/**
* | output |
* | --- |
* | "Project URL" |
*
* @param {Projects_UrlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_url = /** @type {((inputs?: Projects_UrlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_UrlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_url(inputs)
	return cs_projects_url(inputs)
});